import { useTranslation } from "react-i18next";
import * as yup from "yup";
import { isValidPhoneNumber } from "react-phone-number-input";

function useMarketplaceRequestValidationSchema() {
  const { t } = useTranslation("validationsSchema");

  const schema = yup.object({
    companyName: yup.string().required(t("marketplaceRequest.companyNameRequired")),

    contactFirstName: yup.string().required(t("marketplaceRequest.contactFirstNameRequired")),

    contactLastName: yup.string().required(t("marketplaceRequest.contactLastNameRequired")),

    phone: yup
      .string()
      .required(t("marketplaceRequest.phoneRequired"))
      .test("valid-phone", t("marketplaceRequest.phoneInvalid"), (value) =>
        isValidPhoneNumber(value || ""),
      ),

    email: yup
      .string()
      .email(t("marketplaceRequest.emailInvalid"))
      .required(t("marketplaceRequest.emailRequired")),

    eventAddress: yup.string().required(t("marketplaceRequest.eventAddressRequired")),

    invoiceAddress: yup.string().required(t("marketplaceRequest.invoiceAddressRequired")),

    eventType: yup.string().optional(),

    startDate: yup
      .date()
      .required(t("marketplaceRequest.startDateRequired"))
      .typeError(t("marketplaceRequest.startDateRequired")),

    endDate: yup
      .date()
      .required(t("marketplaceRequest.endDateRequired"))
      .typeError(t("marketplaceRequest.endDateRequired"))
      .min(yup.ref("startDate"), t("marketplaceRequest.endDateAfterStart")),

    request: yup.string().optional(),
  });

  return schema;
}

export default useMarketplaceRequestValidationSchema;
